@if (isMatchDataLoading()) {
  <section class="match-detail__loading sb-card-shell" aria-busy="true" aria-live="polite">
    <h2>{{ 'matchDetail.loading' | translate }}</h2>

    <div class="match-detail__loading-dots" aria-hidden="true">
      <span></span>
      <span></span>
      <span></span>
    </div>
  </section>
} @else if (matchDetail(); as detail) {
  <section class="match-detail">
    <div class="match-detail__back-track">
      <button type="button" class="match-detail__back-link" (click)="goBack()">
        <span class="material-symbols-outlined match-detail__back-icon" aria-hidden="true">chevron_left</span>
        <span>{{ 'matchDetail.back' | translate }}</span>
      </button>
    </div>

    <app-match-detail-hero [detail]="detail"></app-match-detail-hero>

    <nav class="match-detail__tabs sb-scrollbar" [attr.aria-label]="'matchDetail.tabs' | translate">
      @for (tab of detail.tabs; track trackTab($index, tab)) {
        <button
          type="button"
          class="match-detail__tab"
          [class.match-detail__tab--active]="currentTabId() === tab.id"
          [attr.aria-pressed]="currentTabId() === tab.id"
          (click)="setActiveTab(tab.id)"
        >
          {{ tab.label }} ({{ tab.count }})
        </button>
      }
    </nav>

    <section class="match-detail__markets">
      @for (section of visibleSections(); track trackSection($index, section)) {
        <app-match-detail-market-group
          [section]="section"
          [matchId]="detail.id"
          (selectionToggle)="sportsbook.toggleSelection($event)"
        ></app-match-detail-market-group>
      } @empty {
        <div class="match-detail__empty sb-card-shell">
          <h2>{{ 'matchDetail.emptyTitle' | translate }}</h2>
          <p>{{ 'matchDetail.emptyDescription' | translate }}</p>
        </div>
      }
    </section>
  </section>
} @else {
  <section class="match-detail__missing sb-card-shell">
    <h2>{{ 'matchDetail.missingTitle' | translate }}</h2>
    <p>{{ 'matchDetail.missingDescription' | translate }}</p>
    <button type="button" class="match-detail__missing-link" (click)="goBack()">{{ 'matchDetail.back' | translate }}</button>
  </section>
}
